import { useEffect, useState } from "react";
import Loader from "../../../components/loader";
import { OrderStatusEnumEntity, StorageKeyEnum } from "../../../utils/enum";
import { CityDDLEntity, PaginateRespEntity, StateDDLEntity, UsersEntity } from "../../../interface";
import { CountryDDLEntity, GetAllOrdersReqEntityV1, OrderDetailsEntity } from "../../../interface/order";
import { APIResponseEntity } from "../../../interface/api-responce";
import { APIFetchAllOrderDetailsV2, APIGetCitiesForOrdersDDL, APIGetCountryDDL, APIGetStateForOrdersDDL, APIUserResignation } from "../../../service/api-service";
import { AxiosResponse } from "axios";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { IsNullOrEmptyArray, IsStringNullEmptyOrUndefined } from "../../../utils/null-check";
import { Dropdown } from "primereact/dropdown";
import { toast } from "react-toastify";
import { toastOptObj } from "../../../utils/constants";
import { DataTable } from "primereact/datatable";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { InputText } from "primereact/inputtext";
import PrimePaginator from "../../../components/prime-paginator";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import ReassignProjectsDialog from "./reassign-projects-dialog";
import { useNavigate } from "react-router-dom";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from "primereact/dialog";
import { useRef } from "react";
import { MultiSelect } from "primereact/multiselect";

const DEFAULT_ORDER_STATUS = [
    OrderStatusEnumEntity.DRAFT,
    OrderStatusEnumEntity.PIPELINE,
    OrderStatusEnumEntity.COMMERCIALHOLD,
    OrderStatusEnumEntity.COMMERCIALWIN,
    OrderStatusEnumEntity.HANDOVER,
    OrderStatusEnumEntity.LOST,
    OrderStatusEnumEntity.PRECLOSURE,
    OrderStatusEnumEntity.FULL_DISPATCH,
    OrderStatusEnumEntity.HANDOVER_PENDING,
    OrderStatusEnumEntity.FEEDBACK,

];

function UserReassignment() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedUser, setSelectedUser] = useState<UsersEntity | null>(null);
    const [countryDDL, setCountryDDL] = useState<CountryDDLEntity[] | []>([]);
    const [stateDDL, setStateDDL] = useState<StateDDLEntity[] | []>([]);
    const [cityDDL, setCityDDL] = useState<CityDDLEntity[] | []>([]);
    const [selectedOrderDetails, setSelectedOrderDetails] = useState<OrderDetailsEntity[] | []>([]);
    const [orderDetails, setOrderDetails] = useState<OrderDetailsEntity[] | []>([]);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [selectedCountryName, setSelectedCountryName] = useState<string>("");
    const [selectedStateName, setSelectedStateName] = useState<string>("");
    const [selectedCityName, setSelectedCityName] = useState<string>("");
    const [fromDate, setFromDate] = useState<Date | null>(null);
    const [toDate, setToDate] = useState<Date | null>(null);
    const [selectedOrderIds, setSelectedOrderIds] = useState<string[]>([]);
    const [showReassignDialog, setShowReassignDialog] = useState<boolean>(false);
    const [showSuccessDialog, setShowSuccessDialog] = useState<boolean>(false);
    const [successMessage, setSuccessMessage] = useState<string>("");
    const [isDefaultStatusFilter, setIsDefaultStatusFilter] = useState<boolean>(true);
    const orderMultiselectRef = useRef<any>(null);

    const wallOrderStatus = [
        { name: "Draft", status: OrderStatusEnumEntity.DRAFT },
        { name: "Pipeline", status: OrderStatusEnumEntity.PIPELINE },
        { name: "Commercial Hold", status: OrderStatusEnumEntity.COMMERCIALHOLD },
        { name: "Win", status: OrderStatusEnumEntity.COMMERCIALWIN },
        { name: "Handover", status: OrderStatusEnumEntity.HANDOVER },
        { name: "Handover Pending", status: OrderStatusEnumEntity.HANDOVER_PENDING },
        { name: "Feedback", status: OrderStatusEnumEntity.FEEDBACK },
        { name: "Lost", status: OrderStatusEnumEntity.LOST },
        { name: "Pre Closure", status: OrderStatusEnumEntity.PRECLOSURE },
        { name: "Full Dispatch", status: OrderStatusEnumEntity.FULL_DISPATCH },
    ];

    const [filterReq, setFilterReq] = useState<GetAllOrdersReqEntityV1>({
        APICallCount: 0,
        orderStatus: `${OrderStatusEnumEntity.DRAFT}||${OrderStatusEnumEntity.PIPELINE}||${OrderStatusEnumEntity.COMMERCIALHOLD}||${OrderStatusEnumEntity.COMMERCIALWIN}||${OrderStatusEnumEntity.HANDOVER}||${OrderStatusEnumEntity.LOST}||${OrderStatusEnumEntity.PRECLOSURE}||${OrderStatusEnumEntity.FULL_DISPATCH}||${OrderStatusEnumEntity.HANDOVER_PENDING}||${OrderStatusEnumEntity.FEEDBACK}`,
        pageSize: 10,
        pageNumber: 0,
        sortColumn: "orderActualDate",
        sortOrder: "desc",
        createdBy: [],
    });
    const isFilterApplied = !!filterReq.searchByOrderNumber || !!filterReq.searchByProjectName || !!filterReq.searchByClientName || !!filterReq.searchByCountry || !!filterReq.searchByState || !!filterReq.searchByCity || !!filterReq.orderFromDate || !!filterReq.orderToDate || !isDefaultStatusFilter;
    const [tempOrderStatus, setTempOrderStatus] = useState<string[]>([]);

    const fetchOrders = async (): Promise<void> => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIFetchAllOrderDetailsV2(filterReq);
        setIsLoading(false);
        setOrderDetails([]);
        setTotalPageCount(0);
        if (resp && resp.data && resp.status === 200) {
            const axiosResp: APIResponseEntity = resp.data;
            if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                const paginateResp: PaginateRespEntity = axiosResp.data;
                setOrderDetails(paginateResp.data);
                setTotalPageCount(paginateResp.totalCount);
            }
        }
    };

    const fetchCountryDDL = async (): Promise<void> => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIGetCountryDDL();
        setIsLoading(false);
        if (resp) {
            if (resp.status === 200 && resp.data) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    axiosResp.data.data.sort((a: CountryDDLEntity, b: CountryDDLEntity) => a.name.localeCompare(b.name));
                    setCountryDDL(axiosResp.data.data);
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj });
                }
            }
        }
    };

    const fetchStateDDL = async (): Promise<void> => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIGetStateForOrdersDDL();
        setIsLoading(false);
        if (resp) {
            if (resp.status === 200 && resp.data) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    axiosResp.data.data.sort((a: CountryDDLEntity, b: CountryDDLEntity) => a.name.localeCompare(b.name));
                    setStateDDL(axiosResp.data.data);
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj });
                }
            }
        }
    };

    const fetchCityDDl = async (): Promise<void> => {

        if (!selectedStateName || IsStringNullEmptyOrUndefined(selectedStateName)) {
            return;
        }
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIGetCitiesForOrdersDDL(+selectedStateName);
        setIsLoading(false);
        if (resp) {
            if (resp.status === 200 && resp.data) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    axiosResp.data.data.sort((a: CountryDDLEntity, b: CountryDDLEntity) => a.name.localeCompare(b.name));
                    setCityDDL(axiosResp.data.data);
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj });
                }
            }
        }
    };

    const handleCompleteReassignment = async (): Promise<void> => {
        if (!selectedUser) return;
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIUserResignation(selectedUser.id);
        setIsLoading(false);
        if (resp) {
            if (resp.status === 200 && resp.data) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.data.messages && axiosResp.status && axiosResp.statusCode === 200) {
                    setSuccessMessage(axiosResp.data.messages);
                    setShowSuccessDialog(true);
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj });
                }
            }
        }
    };

    const onPageChange = (event: PaginatorPageChangeEvent) => {

        setFilterReq(prev => ({
            ...prev,
            pageSize: event.rows,
            pageNumber: event.page,
            APICallCount: prev.APICallCount! + 1,
        }));
    };

    const handleChangeCountryName = (value: any) => {
        setSelectedCountryName(value);
        setSelectedStateName("");
        setSelectedCityName("");
        setStateDDL([]);
        setCityDDL([]);
        setFilterReq(prev => ({
            ...prev,
            searchByCountry: value,
            searchByState: "",
            searchByCity: "",
            pageNumber: 0,
            APICallCount: prev.APICallCount! + 1
        }));
    };

    const handleChangeStateName = (value: any) => {
        setSelectedStateName(value);
        setSelectedCityName("");
        setCityDDL([]);
        setFilterReq(prev => ({
            ...prev,
            searchByState: value,
            searchByCity: "",
            pageNumber: 0,
            APICallCount: prev.APICallCount! + 1
        }));
    };

    const handleChangeCityName = (value: any) => {
        setSelectedCityName(value);
        setFilterReq(prev => ({
            ...prev,
            searchByCity: value,
            pageNumber: 0,
            APICallCount: prev.APICallCount! + 1
        }));
    };
    useEffect(() => {
        const userDetails = localStorage.getItem(StorageKeyEnum.USER_REASSIGN_DETAILS);
        if (userDetails) {
            const user = JSON.parse(userDetails);
            setSelectedUser(user);
            setFilterReq(prev => ({
                ...prev,
                createdBy: [user.id],
                APICallCount: prev.APICallCount! + 1
            }));
        }
    }, []);
    useEffect(() => {
        if (filterReq.createdBy.length > 0) {
            fetchOrders();
        }
    }, [filterReq.APICallCount]);
    useEffect(() => {
        const fetchDefaultData = async () => {
            await fetchCountryDDL();
        };
        fetchDefaultData();
    }, []);

    useEffect(() => {
        if (selectedCountryName && !IsStringNullEmptyOrUndefined(selectedCountryName)) {
            fetchStateDDL();
        }
    }, [selectedCountryName]);

    useEffect(() => {
        if (selectedStateName && !IsStringNullEmptyOrUndefined(selectedStateName)) {
            fetchCityDDl();
        }
    }, [selectedStateName]);
    const countryFilterTemplate = () => {
        return (
            <Dropdown
                value={selectedCountryName}
                options={countryDDL}
                optionLabel="name"
                optionValue="id"
                filter
                resetFilterOnHide
                placeholder="Select Country"
                className="p-column-filter"
                onChange={(e) =>
                    handleChangeCountryName(e.value)
                }
            />
        );
    };
    const stateFilterTemplate = () => {
        return (
            <Dropdown
                value={selectedStateName}
                options={stateDDL}
                optionLabel="name"
                optionValue="id"
                filter
                resetFilterOnHide
                placeholder="Select State"
                disabled={!selectedCountryName}
                className="p-column-filter"
                onChange={(e) =>
                    handleChangeStateName(e.value)
                }
            />
        );
    };

    const cityFilterTemplate = () => {
        return (
            <Dropdown
                value={selectedCityName}
                options={cityDDL}
                optionLabel="name"
                optionValue="id"
                filter
                resetFilterOnHide
                placeholder="Select City"
                disabled={!selectedStateName}
                className="p-column-filter"
                onChange={(e) =>
                    handleChangeCityName(e.value)
                }
            />
        );
    };

    const filterTemplateOrderNumber = (options: ColumnFilterElementTemplateOptions) => {
        return (
            <InputText
                value={filterReq.searchByOrderNumber}
                placeholder="Search by order number"
                onChange={(e) =>
                    setFilterReq(prev => ({
                        ...prev,
                        searchByOrderNumber: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount! + 1
                    }))
                }
            />
        );
    };

    const filterTemplateProjectName = (options: ColumnFilterElementTemplateOptions) => {
        return (
            <InputText
                value={filterReq.searchByProjectName}
                placeholder="Search by project name"
                onChange={(e) =>
                    setFilterReq(prev => ({
                        ...prev,
                        searchByProjectName: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount! + 1
                    }))
                }
            />
        );
    };
    const filterTemplateClientName = (options: ColumnFilterElementTemplateOptions) => {
        return (
            <InputText
                value={filterReq.searchByClientName}
                placeholder="Search by client name"
                onChange={(e) =>
                    setFilterReq(prev => ({
                        ...prev,
                        searchByClientName: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount! + 1
                    }))
                }
            />
        );
    };
    const onTableSort = (e: any): void => {
        if (e && e.sortField && e.sortOrder) {
            setFilterReq(prev => ({
                ...prev,
                sortColumn: e.sortField,
                pageNumber: 0,
                APICallCount: prev.APICallCount! + 1,
                sortOrder:
                    prev.sortOrder === "asce" && e.sortOrder === 1
                        ? "desc"
                        : prev.sortOrder === "desc" && e.sortOrder === 1
                            ? "asce"
                            : prev.sortOrder === "asce" && e.sortOrder === -1
                                ? "desc"
                                : "asce"
            }));
        }
    };
    const dateFilterTemplate = () => {
        return (
            <div className="d-flex gap-2">
                <Calendar
                    value={fromDate}
                    placeholder="From"
                    dateFormat="dd/mm/yy"
                    onChange={(e) => {
                        setFromDate(e.value as Date);

                        setFilterReq(prev => ({
                            ...prev,
                            orderFromDate: e.value
                                ? moment(e.value).format("YYYY-MM-DD")
                                : "",
                            APICallCount: prev.APICallCount! + 1
                        }));
                    }}
                />
                <Calendar
                    value={toDate}
                    placeholder="To"
                    dateFormat="dd/mm/yy"
                    onChange={(e) => {
                        setToDate(e.value as Date);

                        setFilterReq(prev => ({
                            ...prev,
                            orderToDate: e.value
                                ? moment(e.value).format("YYYY-MM-DD")
                                : "",
                            APICallCount: prev.APICallCount! + 1
                        }));
                    }}
                />
            </div>
        );
    };

    const statusBodyTemplate = (rowData: OrderDetailsEntity) => {
        const badgeClass =
            rowData.orderStatus === OrderStatusEnumEntity.DRAFT
                ? "bg-primary"
                : rowData.orderStatus === OrderStatusEnumEntity.PIPELINE
                    ? "bg-secondary"
                    : rowData.orderStatus === OrderStatusEnumEntity.COMMERCIALHOLD
                        ? "bg-warning"
                        : rowData.orderStatus === OrderStatusEnumEntity.COMMERCIALWIN
                            ? "bg-info"
                            : rowData.orderStatus === OrderStatusEnumEntity.HANDOVER
                                ? "bg-success"
                                : rowData.orderStatus === OrderStatusEnumEntity.LOST
                                    ? "bg-coral"
                                    : rowData.orderStatus === OrderStatusEnumEntity.PRECLOSURE
                                        ? "bg-indigo"
                                        : rowData.orderStatus === OrderStatusEnumEntity.HANDOVER_PENDING
                                            ? "bg-sand"
                                            : rowData.orderStatus === OrderStatusEnumEntity.FEEDBACK
                                                ? "bg-feedback"
                                                : rowData.orderStatus === OrderStatusEnumEntity.FULL_DISPATCH
                                                    ? "bg-full-dispatch"
                                                    : "";

        const status =
            rowData.orderStatus === OrderStatusEnumEntity.DRAFT
                ? "Draft"
                : rowData.orderStatus === OrderStatusEnumEntity.PIPELINE
                    ? "Pipeline"
                    : rowData.orderStatus === OrderStatusEnumEntity.COMMERCIALHOLD
                        ? "Commercial Hold"
                        : rowData.orderStatus === OrderStatusEnumEntity.COMMERCIALWIN
                            ? "Win"
                            : rowData.orderStatus === OrderStatusEnumEntity.HANDOVER
                                ? "Handover"
                                : rowData.orderStatus === OrderStatusEnumEntity.LOST
                                    ? "Lost"
                                    : rowData.orderStatus === OrderStatusEnumEntity.PRECLOSURE
                                        ? "Preclosure"
                                        : rowData.orderStatus === OrderStatusEnumEntity.HANDOVER_PENDING
                                            ? "Handover Pending"
                                            : rowData.orderStatus === OrderStatusEnumEntity.FEEDBACK
                                                ? "Feedback"
                                                : rowData.orderStatus === OrderStatusEnumEntity.FULL_DISPATCH
                                                    ? "Full Dispatch"
                                                    : "";

        return (
            <div className="d-flex justify-content-between gap-1">
                <span className={`badge ${badgeClass}`}>
                    {status}
                </span>
                {rowData.orderPricingVersionId && (
                    <span className="badge rounded-pill bg-success">
                        {rowData.orderPricingVersionId}
                    </span>
                )}
            </div>
        );
    };

    const filterTemplateOrderStatus = (
        options: ColumnFilterElementTemplateOptions
    ) => {
        const panelFooterTemplate = () => (
            <div className="flex justify-between p-2">
                <button
                    className="p-button p-component p-button-sm"
                    onClick={() => {
                        const isDefault = tempOrderStatus.length === 0;

                        setIsDefaultStatusFilter(isDefault);

                        const str = (
                            isDefault
                                ? DEFAULT_ORDER_STATUS
                                : tempOrderStatus
                        ).join("||");

                        setFilterReq((prev) => ({
                            ...prev,
                            orderStatus: str,
                            pageNumber: 0,
                            APICallCount: prev.APICallCount! + 1,
                        }));
                        orderMultiselectRef.current.hide();
                    }}
                >
                    Apply
                </button>
            </div>
        );

        return (
            <MultiSelect
                ref={orderMultiselectRef}
                value={tempOrderStatus}
                onChange={(e) => setTempOrderStatus(e.value)}
                options={wallOrderStatus}
                optionLabel="name"
                optionValue="status"
                placeholder="Select status"
                filter
                maxSelectedLabels={1}
                panelFooterTemplate={panelFooterTemplate}

                onHide={() => {
                    if (isDefaultStatusFilter) {
                        setTempOrderStatus([]);
                    } else {
                        setTempOrderStatus(
                            filterReq.orderStatus
                                ? filterReq.orderStatus.split("||")
                                : []
                        );
                    }
                }}
            />
        );
    };

    const resetFilters = () => {
        setSelectedCountryName("");
        setSelectedStateName("");
        setSelectedCityName("");
        setStateDDL([]);
        setCityDDL([]);
        setTempOrderStatus([]);
        setIsDefaultStatusFilter(true);
        setFromDate(null);
        setToDate(null);
        setSelectedOrderDetails([]);
        setSelectedOrderIds([]);
        setFilterReq(prev => ({
            ...prev,
            searchByOrderNumber: "",
            searchByProjectName: "",
            searchByClientName: "",
            searchByCountry: "",
            searchByState: "",
            searchByCity: "",
            orderFromDate: "",
            orderToDate: "",
            orderStatus: `${OrderStatusEnumEntity.DRAFT}||${OrderStatusEnumEntity.PIPELINE}||${OrderStatusEnumEntity.COMMERCIALHOLD}||${OrderStatusEnumEntity.COMMERCIALWIN}||${OrderStatusEnumEntity.HANDOVER}||${OrderStatusEnumEntity.LOST}||${OrderStatusEnumEntity.PRECLOSURE}||${OrderStatusEnumEntity.FULL_DISPATCH}||${OrderStatusEnumEntity.HANDOVER_PENDING}||${OrderStatusEnumEntity.FEEDBACK}`,
            pageNumber: 0,
            pageSize: 10,
            sortColumn: "orderActualDate",
            sortOrder: "desc",
            APICallCount: prev.APICallCount! + 1
        }));
    };

    const finalAmountPattern = (rowData: OrderDetailsEntity, country: string) => {
        let finalAmount = "";

        if (!IsStringNullEmptyOrUndefined(rowData.finalAmount)) {
            if (country === "in") {
                finalAmount = Number(rowData.finalAmount).toLocaleString("en-IN");
            }
            if (country === "us") {
                finalAmount = Number(rowData.finalAmount).toLocaleString("en-US");
            }
        }
        return finalAmount;
    };
    return (
        <>
            <Loader isLoading={isLoading} />
            <ConfirmDialog draggable={false} />
            {selectedUser && (
                <div className="content-wrapper">
                    <div className="card card-rounded mb-3">
                        <div className="card-body">
                            <h4 className="card-title mb-4">
                                User Reassigning
                            </h4>
                            <div className="row">
                                <div className="col-lg-4 col-md-4 mb-3">
                                    <strong className="fs-14">User Name</strong>
                                    <span className="d-block fs-14 fw-normal text-muted">
                                        {selectedUser.userName || "-"}
                                    </span>
                                </div>
                                <div className="col-lg-4 col-md-4 mb-3">
                                    <strong className="fs-14">User Full Name</strong>
                                    <span className="d-block fs-14 fw-normal text-muted">
                                        {selectedUser.userFullName || "-"}
                                    </span>
                                </div>
                                <div className="col-lg-4 col-md-4 mb-3">
                                    <strong className="fs-14">Office Name</strong>
                                    <span className="d-block fs-14 fw-normal text-muted">
                                        {selectedUser.officeName || "-"}
                                    </span>
                                </div>
                                <div className="col-lg-4 col-md-4 mb-3">
                                    <strong className="fs-14">Mobile No.</strong>
                                    <span className="d-block fs-14 fw-normal text-muted">
                                        {selectedUser.mobileNo || "-"}
                                    </span>
                                </div>
                                <div className="col-lg-4 col-md-4 mb-3">
                                    <strong className="fs-14">Email Address</strong>
                                    <span className="d-block fs-14 fw-normal text-muted">
                                        {selectedUser.emailAddress || "-"}
                                    </span>
                                </div>
                                <div className="col-lg-4 col-md-4 mb-3">
                                    <strong className="fs-14">Role Name</strong>
                                    <span className="d-block fs-14 fw-normal text-muted">
                                        {selectedUser.roleName || "-"}
                                    </span>
                                </div>
                            </div>
                            <div
                                className="alert alert-danger d-flex align-items-center mb-3"
                                role="alert"
                            >
                                <strong className="me-1">Important:</strong>
                                <span>
                                    This process will reassign <b>ALL</b> projects from the selected employee
                                    and mark the employee as inactive. This action is typically used for
                                    employee resignation or termination.
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="card card-rounded">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="card-title mb-0">
                                    Assigned Projects
                                </h4>
                                <span
                                    className="resetFilters text-primary"
                                    style={{ cursor: "pointer" }}
                                    onClick={resetFilters}
                                >
                                    Reset Filters
                                </span>
                            </div>
                            {selectedOrderDetails.length > 0 && (
                                <div
                                    className="mb-3 p-2 px-3 rounded"
                                    style={{
                                        background: "#EAF3FF",
                                        border: "1px solid #8EB9FF",
                                        color: "#3B5F9C",
                                        fontSize: "13px"
                                    }}
                                >
                                    {selectedOrderDetails.length} project{selectedOrderDetails.length !== 1 ? "s" : ""} selected for reassignment
                                </div>
                            )}

                            <DataTable
                                value={orderDetails}
                                dataKey="_id"
                                selectionMode="multiple"
                                selection={selectedOrderDetails}
                                onSelectionChange={(e) => {
                                    const selected = e.value as OrderDetailsEntity[];
                                    setSelectedOrderDetails(selected);
                                    setSelectedOrderIds(
                                        selected.map(order => order._id)
                                    );
                                }}
                                filterDisplay="row"
                                responsiveLayout="scroll"
                                sortField={filterReq.sortColumn}
                                sortOrder={filterReq.sortOrder === "asce" ? 1 : -1}
                                onSort={onTableSort}
                            >

                                <Column
                                    selectionMode="multiple"
                                    headerStyle={{ width: "3rem" }}
                                />

                                <Column
                                    field="orderNumber"
                                    header="Order Number"
                                    sortable
                                    filter
                                    showFilterMenu={false}
                                    filterElement={filterTemplateOrderNumber}
                                />

                                <Column
                                    field="projectName"
                                    header="Project Name"
                                    sortable
                                    filter
                                    showFilterMenu={false}
                                    filterElement={filterTemplateProjectName}
                                />

                                <Column
                                    field="clientName"
                                    header="Client Name"
                                    sortable
                                    filter
                                    showFilterMenu={false}
                                    filterElement={filterTemplateClientName}
                                />

                                <Column
                                    field="country"
                                    header="Country"
                                    sortable
                                    filter
                                    showFilterMenu={false}
                                    filterElement={countryFilterTemplate}
                                />

                                <Column
                                    field="state"
                                    header="State"
                                    sortable
                                    filter
                                    showFilterMenu={false}
                                    filterElement={stateFilterTemplate}
                                />

                                <Column
                                    field="city"
                                    header="City"
                                    sortable
                                    filter
                                    showFilterMenu={false}
                                    filterElement={cityFilterTemplate}
                                />
                                <Column
                                    field="orderDate"
                                    header="Date"
                                    sortable
                                    filter
                                    showFilterMenu={false}
                                    filterElement={dateFilterTemplate}
                                    body={(rowData) =>
                                        rowData.orderDate
                                            ? moment(rowData.orderDate).format("DD/MM/YYYY")
                                            : "-"
                                    }
                                />
                                <Column
                                    body={statusBodyTemplate}
                                    field="orderStatus"
                                    header="STATUS"
                                    sortable
                                    showFilterMenu={false}
                                    filter
                                    filterElement={filterTemplateOrderStatus}
                                />
                                <Column
                                    field="finalAmount"
                                    header="FINAL AMOUNT"
                                    bodyStyle={{
                                        textAlign: "end",
                                        paddingRight: "1.2rem",
                                    }}
                                    body={(data) => finalAmountPattern(data, "in")}
                                    sortable
                                />
                            </DataTable>
                            {!IsNullOrEmptyArray(orderDetails) && (
                                <PrimePaginator
                                    onPageChange={onPageChange}
                                    pageNumber={filterReq.pageNumber}
                                    pageSize={filterReq.pageSize}
                                    totalRecords={totalPageCount}
                                />
                            )}
                            <div className="d-flex justify-content-between align-items-center mt-3">

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => { navigate(-1); }}
                                >
                                    Back
                                </button>

                                <div className="d-flex gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        disabled={selectedOrderIds.length === 0}
                                        onClick={() => setShowReassignDialog(true)}
                                    >
                                        Reassign {selectedOrderDetails.length} Project
                                        {selectedOrderDetails.length > 1 ? "s" : ""}
                                    </button>

                                    {totalPageCount === 0 && !isFilterApplied && (
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={() =>
                                                confirmDialog({
                                                    header: "Resignation Confirmation",
                                                    message: `Are you sure you want to resign ${selectedUser.userFullName}?`,
                                                    icon: "pi pi-exclamation-triangle",
                                                    acceptLabel: "Yes",
                                                    rejectLabel: "No",
                                                    acceptClassName: "p-button-danger",
                                                    rejectClassName: "p-button-text",
                                                    accept: handleCompleteReassignment
                                                })
                                            }
                                        >
                                            Complete Project Reassignment &amp; Begin Resignation
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }
            {selectedUser && (
                <ReassignProjectsDialog
                    visible={showReassignDialog}
                    onHide={() => setShowReassignDialog(false)}
                    selectedOrders={selectedOrderDetails}
                    userId={selectedUser.id}
                    onSuccess={() => {
                        setShowReassignDialog(false);
                        setSelectedOrderDetails([]);
                        setSelectedOrderIds([]);
                        setOrderDetails([]);

                        setFilterReq(prev => ({
                            ...prev,
                            APICallCount: prev.APICallCount! + 1
                        }));
                    }}
                />
            )}
            <Dialog
                visible={showSuccessDialog}
                closable={false}
                modal
                draggable={false}
                resizable={false}
                style={{ width: "20vw" }}
                onHide={() => setShowSuccessDialog(false)}
            >
                <div className="d-flex flex-column align-items-center text-center gap-2">
                    <img
                        src="assets/images/success.svg"
                        alt="success"
                        width={70}
                        className="mx-auto my-2"
                    />
                    <h4 className="fw-bold">
                        User Reassigned
                    </h4>
                    <div className="text-center">
                        <p className="mb-0">
                            {successMessage}
                        </p>
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary w-75 mx-auto mt-2"
                        onClick={() => {
                            setShowSuccessDialog(false);
                            navigate(-1);
                        }}
                    >
                        OK
                    </button>
                </div>
            </Dialog>
        </>
    );
}

export default UserReassignment;